import get from 'lodash/get'

export const shouldDisplaySlice = (display, {
  isPageOwner,
  isTeamOwner,
  sessionPage,
  sessionTeam,
  tagPage,
  team,
  user
}) => {
  switch (display) {
    case 'public only':
      return !get(user, 'id')
    case 'authenticated only':
      return !!get(user, 'id')
    case 'has page':
      return !!get(sessionPage, 'id')
    case 'has team':
      return !!get(sessionTeam, 'id')
    case 'page owner':
      return isPageOwner
    case 'team owner':
      return isTeamOwner
    case 'team member':
      return get(team, 'id') === get(sessionTeam, 'id')
    case 'has tag':
      return get(sessionPage, 'tags', []).filter(({ tagDefinition, value }) =>
        tagDefinition.id === tagPage.tagId && value === tagPage.name
      ).length
    default:
      return true
  }
}
